<script setup>
import { computed } from 'vue'
import i18n from '@/plugins/i18n'

const t = i18n.global.t

const props = defineProps({
  current: { type: Number, default: 0 },
  total: { type: Number, default: 0 },
  progress: { type: Number, default: 0 },
  loading: { type: Boolean, default: false },
  slider_label: { type: String, default: '' }
})

const currentOfTotal = computed(() => {
  const totalDisplay = props.total ?? t('scheduled.limits.unlimited')

  return `${props.current} / ${totalDisplay}`
})</script>

<template>
  <q-card>
    <q-card-section>
      <div class="row q-col-gutter-md items-center q-pa-sm">
        <div class="col-12">
          <div class="row items-center no-wrap">
            <div class="text-caption text-grey-7 q-mr-sm">
              {{ $t(props.slider_label) }}
            </div>
            <div class="text-body2 q-ml-auto">
              {{ currentOfTotal }}
            </div>
          </div>
          <q-linear-progress
            class="q-mt-sm"
            :value="(props.progress || 0) / 100"
            color="primary"
            track-color="grey-3"
            :indeterminate="props.loading"
          />
        </div>
      </div>
    </q-card-section>
  </q-card>
</template>
